// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__owgbn","placeholdersHeader":"styles_placeholdersHeader__ih6Ri","editorStyle":"styles_editorStyle__1PF82","placeholdersBox":"styles_placeholdersBox__1n5Iy"};